import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import socket from '../../services/socketService';

export default function SocketListeners() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleMessage = (droneStatusData) => {
      if (!droneStatusData) {
        return;
      }
      const latency =
        Math.abs(
          new Date().getTime() -
            new Date(droneStatusData.timestamp * 1000).getTime()
        ) / 1000;
      const updatedDroneStatusData = { ...droneStatusData, latency };

      if (updatedDroneStatusData) {
        // Update React Query cache with new data
        queryClient.setQueryData(
          ['droneStatus', updatedDroneStatusData.name],
          updatedDroneStatusData
        );

        // Invalidate the query so it refetches the new data immediately
        queryClient.invalidateQueries([
          'droneStatus',
          updatedDroneStatusData.name,
        ]);
      }
    };

    // Attach the listener for 'dronestatus' events
    socket.on('dronestatus', handleMessage);

    // Cleanup listener on component unmount
    return () => {
      socket.off('dronestatus', handleMessage);
      // Remove cache for this specific query
      queryClient.removeQueries({
        queryKey: ['droneStatus'],
        type: 'inactive',
      });
    };
  }, [queryClient]);

  return null;
}
